export default "/images/vendor/flag-icon-css/flags/4x3/nu.svg?770e6779515b496ac3b67e6f0a207c7e";